export { default } from './Events';



// WEBPACK FOOTER //
// ./src/js/views/events/index.js